// extracted by mini-css-extract-plugin
module.exports = {"container":"InputAreaBG_container__3EXwz","read-only-span":"InputAreaBG_read-only-span__gLr9h"};